import { ProductLookupClause, ProductSearchCriteria } from "@msdyn365-commerce/retail-proxy";
import { getCatalogId, ICoreContext } from '@msdyn365-commerce/core';
import { searchByCriteriaAsync } from "@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g";
import { attrNames } from "./global-constants";

export async function productErrorHandling(ItemIds: string[], context: ICoreContext<{ [x: string]: any; }>): Promise<{ productId: string, errorMessage: string }[]> {

    const erroredItemList: { productId: string, errorMessage: string }[] = [];

    const searchedClauses: ProductLookupClause[] = ItemIds.map(itemId => {
        return { ItemId: itemId };
    });

    const searchCriteria: ProductSearchCriteria = {
        ItemIds: searchedClauses,
        Context: {
            ChannelId: context.request.apiSettings.channelId,
            CatalogId: getCatalogId(context.request)
        },
        IncludeAttributes: true
    };

    const searchByCriteriaResult = await searchByCriteriaAsync({ callerContext: context.actionContext }, searchCriteria);

    ItemIds.forEach(itemId => {
        const product = searchByCriteriaResult.find(currentItem => {
            return currentItem.ItemId === itemId;
        });
        if (product) {
                if (product.AttributeValues?.find(attribute => {
                    return attribute.Name === attrNames.attributeValueItemNotAvailable;
                })?.BooleanValue) {
                    erroredItemList.push({ productId: product.ItemId || '', errorMessage: "Item is NLA" });
                }
                if (product.AttributeValues?.find(attribute => {
                    return attribute.Name === attrNames.attributeValueItemLTL;
                })?.BooleanValue) {
                    erroredItemList.push({ productId: product.ItemId || '', errorMessage: "Item is Overweight" });
                }
        } else {
            erroredItemList.push({ productId: itemId.toString() || '', errorMessage: "Item Id does not exist" });
        }
    });

    return erroredItemList;
}